import Vue from 'vue'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'

Vue.component(FeatherIcon.name, FeatherIcon)
Vue.prototype.pdfQuality = 5 // todo Onerilen 5 tir. Gelen feedbacklere göre pdf oluşturma yavaş çalışıyor ise bu sayısı düşürünüz.
